import { useQueryExportQuestions } from "@/api/export/export";
import { Button } from "@/components/atoms/Button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/atoms/Dialog";
import { downloadFile } from "@/lib/download-file";
import { formatDate } from "@/lib/utils";
import { HttpStatusCode } from "axios";
import { useEffect, useState } from "react";
import { toast } from "sonner";

const ExportDialog = () => {
  const [open, setOpen] = useState(false);

  const { isLoading, isError, error, refetch, data } =
    useQueryExportQuestions();

  // display error
  useEffect(() => {
    if (!isError) return;

    switch (error.response?.status) {
      case HttpStatusCode.NotImplemented:
        toast.error("Export non implémenté pour l'instant.");
        return;

      default:
        toast.error("Échec de l'export");
    }
  }, [isError, error?.response?.status]);

  // download file
  useEffect(() => {
    if (!data) return;

    downloadFile(data, `questions-${formatDate()}.xlsx`);
  }, [data]);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button className="gap-1 px-3" variant="outline">
          Exporter
        </Button>
      </DialogTrigger>
      <DialogContent className="p-4">
        <DialogHeader>
          <DialogTitle>Export des questions</DialogTitle>
          <DialogDescription hidden>Export des questions</DialogDescription>
        </DialogHeader>
        <Button disabled={isLoading} onClick={() => refetch()}>
          {isLoading ? "Export en cours..." : "Exporter"}
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default ExportDialog;
